export default "__VITE_ASSET__W3w6GHwW__"